import React from 'react';
import { Box } from '@mui/material';
import { useGoogleSSO } from './hooks/useGoogleSSO';
import { useSelector } from 'react-redux';
import { UserData } from './model/User';
import { AxiosResponse } from 'axios';
import { ApplicationState } from 'store/store';
import { SSO_BUTTON_MAX_WIDTH } from 'config/constants';
import { Throbber } from 'lib/Throbber';

interface GoogleSSOProps {
    onSignInSuccess: (data: UserData) => void;
    onSignInError: (error: AxiosResponse<{ message: string; code: string }>) => void;
    onStart?: () => void;
}

export const GoogleSSO: React.FC<React.PropsWithChildren<GoogleSSOProps>> = ({
    onSignInSuccess,
    onSignInError,
    onStart
}) => {
    const { settings } = useSelector((state: ApplicationState) => state.settings);

    const { googleSSOId, container, loading } = useGoogleSSO(onSignInSuccess, onSignInError, onStart);
    if (!settings?.googleSSOEnabled) {
        return null;
    }
    // Flex item: grows up to the SSO max width, but never narrower than 200px (Google's button
    // won't render below its content width). The wrapping row sits us beside Apple when there's
    // room for both at this minimum, and wraps us to our own row when there isn't.
    return (
        <Box ref={container} sx={{ flex: '1 1 240px', minWidth: 200, maxWidth: SSO_BUTTON_MAX_WIDTH }}>
            <Box display="flex" justifyContent="center">
                <div id={googleSSOId} />
            </Box>
            {loading && <Throbber isFullScreen text="" />}
        </Box>
    );
};
